var base = require("settings/teams/team-members");

Vue.component("spark-team-members", {
    mixins: [base],

    data() {
        return {
            locations: [],
            
            frequency:[{'id':'1','name': 'Daily'},{'id':'2','name': 'Weekly'}, {'id':'3','name': 'Monthly'}],

            updateTeamMemberForm: $.extend(
                true,
                new SparkForm({
                    role: "",
                    location_ids: [],
                    reports: false,
                    frequency_delivery: [],
                }),
                Spark.forms.updateTeamMember
            ),
        };
    },

    methods: {
        canEditTeamMember(member) {
            return this.user.is_account_owner && this.user.id !== member.id && member.id !== this.team.owner_id && (this.user.is_company_admin ||this.user.is_team_owner || member.is_company_admin === false);
        },

        canDeleteTeamMember(member) {
            return this.user.is_account_owner && this.user.id !== member.id && member.id !== this.team.owner_id && (this.user.is_company_admin ||this.user.is_team_owner || member.is_company_admin === false);
        },


        editTeamMember(member) {
            this.updatingTeamMember = member;
            this.updateTeamMemberForm.role = member.pivot.role;



            this.updateTeamMemberForm.reports = member.can_receive_reports;
            this.getLocationsOf(this.user)
                .then(locations => 
                    this.updateTeamMemberForm.location_ids = locations.filter(
                        location => member.accessible_location_ids.includes(location.id)
                    ));

            this.getFrequencyOf(member);


            $("#modal-update-team-member").modal("show");
        },

        getLocationsOf(user) {
            return this.$http.get(this.$laroute.route('api.users.accessible-locations', { user: user.id }))
                .then(({ data }) => this.locations = data.data);
        },

        getFrequencyOf(member) {
            return this.$http.get(this.$laroute.route('api.users.frequency-report', { user: member.id }))
                // .then(({ data }) => this.frequency = data.data);
                .then(
                    response=>{
                        // request ok
                        this.updateTeamMemberForm.frequency_delivery = [];
                        this.updateTeamMemberForm.frequency_delivery = response.data;
                    }, response=>{
                        // bad request
                        console.log(response);
                    }

                );  
        },
        
        teamMemberRole(member) {
            if (this.roles.length == 0) {
                return "";
            }

            if (this.team.owner_id === member.id) {
                return "Owner";
            }

            const role = _.find(
                this.roles,
                role => role.value === member.pivot.role
            );

            if (typeof role !== "undefined") {
                return role.text;
            }
        }
    }
});
